import React from 'react';

import GlassesIcon from '@atlaskit/icon/core/glasses';

export const ToneEducationalIcon = (): React.JSX.Element => (
	<GlassesIcon label="" color="currentColor" spacing="spacious" />
);
